var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "squadra_info white--text" }, [
    _c("div", { staticClass: "squadra-info-crediti" }, [
      _c(
        "div",
        { staticClass: "squadra-info-valore" },
        [
          _c("span", { staticClass: "squadra-info-label" }, [
            _vm._v("Crediti residui"),
          ]),
          _vm._v(" "),
          _c("crediti", {
            staticClass: "squadra-info-importo",
            attrs: { crediti: _vm.crediti, "use-icon": "" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "squadra-info-valore" }, [
        _c("span", { staticClass: "squadra-info-label" }, [
          _vm._v("Offerta massima"),
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "squadra-info-max" },
          [
            _c("v-icon", { attrs: { small: "", color: "white" } }, [
              _vm._v("trending_up"),
            ]),
            _vm._v("\n        " + _vm._s(_vm.maxofferta) + "\n      "),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "squadra-info-ruoli" },
      _vm._l(_vm.ruoli_array, function (ruolo) {
        return _c(
          "div",
          {
            key: ruolo,
            staticClass: "squadra-info-ruolo",
            style: { color: "var(--ruolo-" + ruolo + ")" },
            attrs: { title: _vm.Constants.RUOLI_NEW[ruolo].plurale },
          },
          [
            _c(
              "div",
              { staticClass: "squadra-info-conteggio" },
              [
                _c(
                  "span",
                  {
                    staticClass: "squadra-info-lettera Ruolo font-weight-bold",
                    class: "Ruolo_" + ruolo,
                  },
                  [_vm._v(_vm._s(_vm.Constants.RUOLI_NEW[ruolo].abc))]
                ),
                _vm._v(" "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.acquistiPerRuolo(ruolo, _vm.id_squadra))),
                ]),
                _vm._v(" "),
                _vm.acquistiCompletati(ruolo, _vm.id_squadra)
                  ? _c(
                      "v-icon",
                      {
                        staticClass: "squadra-info-completato",
                        attrs: {
                          "aria-label":
                            _vm.Constants.RUOLI_NEW[ruolo].plurale +
                            ": completati",
                        },
                      },
                      [_vm._v("check")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "squadra-info-limite" },
              [
                _vm.asta_info.lega.nRuoli.op === "illimitati"
                  ? [_vm._v("\n          Senza limite\n        ")]
                  : [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.prefixAcquistabiliPerRuolo() || "su") +
                          "\n          "
                      ),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.acquistabiliPerRuolo(ruolo))),
                      ]),
                    ],
              ],
              2
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }